// Unsplash photos (https://unsplash.com/license — free to use). Swap for real Origo photography when available.
export const u = (id, w = 900) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=75`;

export const IMG = {
  hero: ['1497366811353-6870744d04b2', '1497215728101-856f4ea42174', '1498050108023-c5249f4df085'],
  about: ['1486406146926-c627a92ad1ab', '1519085360753-af0119f7cbe7'],
  band: '1462899006636-339e08d1844e',
  cta: '1497366216548-37526070297c',
  approach: ['1460925895917-afdab827c52f', '1561070791-2526d30994b5', '1555066931-4365d14bab8c'],
  gallery: ['1497366811353-6870744d04b2', '1497215728101-856f4ea42174', '1497366216548-37526070297c', '1486406146926-c627a92ad1ab', '1462899006636-339e08d1844e', '1498050108023-c5249f4df085'],
  team: ['1560250097-0b93528c311a', '1573497019940-1c28c88b4f3e', '1519085360753-af0119f7cbe7', '1573497161161-c3e73707e25c', '1531427186611-ecfd6d936c79', '1563132337-f159f484226c'],
  service: {
    'web-development': '1498050108023-c5249f4df085',
    'mobile-app-development': '1512941937669-90a1b58e7e9c',
    'ui-ux-design': '1561070791-2526d30994b5',
    'graphic-design-branding': '1558655146-9f40138edfeb',
    'animation-motion-graphics': '1542831371-29b0f74f9713',
    'ecommerce-solutions': '1441986300917-64674bd600d8',
    'custom-software-development': '1555066931-4365d14bab8c',
    'seo-digital-marketing': '1432888498266-38ffec3eaf0a',
    'social-media-marketing': '1497215728101-856f4ea42174',
    'cloud-devops': '1558494949-ef010cbdcc31',
    'ai-automation': '1560472354-b33ff0c44a43',
    'qa-software-testing': '1518770660439-4636190af475',
  },
  project: {
    'northwind-analytics': '1551288049-bebda4e38f71',
    'orbit-health': '1512941937669-90a1b58e7e9c',
    'lumen-commerce': '1441986300917-64674bd600d8',
    'atlas-rebrand': '1561070791-2526d30994b5',
    'halo-explainer': '1542831371-29b0f74f9713',
    'ferro-logistics': '1563986768609-322da13575f3',
  },
  process: ['1498050108023-c5249f4df085', '1561070791-2526d30994b5', '1555066931-4365d14bab8c', '1460925895917-afdab827c52f', '1497215728101-856f4ea42174'],
  industry: {
    'Healthcare': '1551288049-bebda4e38f71',
    'Fintech': '1554224155-6726b3ff858f',
    'E-Commerce & Retail': '1441986300917-64674bd600d8',
    'Education': '1503676260728-1c00da094a0b',
    'Logistics': '1586528116311-ad8dd3c8310d',
    'Real Estate': '1560518883-ce09059eeffa',
    'SaaS & Startups': '1531297484001-80022131f5a1',
    'Hospitality': '1566073771259-6a8506099945',
  },
  life: {
    'annual-picnic': '1529156069898-49953e39b3ac',
    'team-outings': '1511632765486-a01980e01a18',
    'birthday-parties': '1464349153735-7db50ed83c84',
    'ramazan-iftar': '1555939594-58d7cb561ad1',
    'eid-celebrations': '1511795409834-ef04bbd61622',
    'sports-days': '1540747913346-19e32dc3e97e',
    'learning-days': '1497366811353-6870744d04b2',
    'office-life': '1497032628192-86f99bcd76bc',
  },
  post: ['1460925895917-afdab827c52f', '1512941937669-90a1b58e7e9c', '1561070791-2526d30994b5', '1542831371-29b0f74f9713', '1432888498266-38ffec3eaf0a', '1558494949-ef010cbdcc31'],
};
